import { Action, createAction } from 'redux-actions';
import { SubmitFormHandler } from '../types';

export type RedirectToFastSearch = {
	engineUrl: string;
	hotelsUrl?: Promise<string>;
	openOfferHotelsStrategy?: 'newTab' | 'currentTab';
};

export const SUBMIT_FORM = 'SUBMIT_FORM';
export const REDIRECT_TO_FAST_SEARCH = 'REDIRECT_TO_FAST_SEARCH';

export type SubmitFormAction = Action<SubmitFormHandler>;

export const submitForm = createAction(SUBMIT_FORM, (onSubmit: SubmitFormHandler) => onSubmit);
export const redirectToFastSearch = createAction<RedirectToFastSearch>(REDIRECT_TO_FAST_SEARCH);
